/**
 * @flow
 */

import { addLocaleData } from 'react-intl';
import isLocaleSupported from 'intl-locales-supported';
import negotiateLocale from './negotiate-locale';

export const DEFAULT_LOCALE = 'en';
export const localeMap = {
  en: 'English',
  cs: 'Čeština',
  da: 'Dansk',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  'es-mx': 'Español (Mexico)',
  nl: 'Nederlands',
  'nl-be': 'Nederlands (België)',
  nb: 'Norsk Bokmål',
  pl: 'Polski',
  fi: 'Suomen kieli',
  sv: 'Svenska'
};

function hasIntl(locale: string): boolean {
  return (window.Intl && isLocaleSupported(locale));
}

export function loadLocaleData(locales: Array<string> | string): Promise<[string, Object]> {
  if (!Array.isArray(locales)) {
    locales = [locales];
  }

  const locale = negotiateLocale(locales, Object.keys(localeMap)) || DEFAULT_LOCALE;

  return new Promise((resolve, reject) => {
    switch (locale) {
      case 'cs':
        if (hasIntl('cs')) {
          require.ensure(['react-intl/locale-data/cs', '../translations/locales/cs.json'], require => {
            const localeData = require('react-intl/locale-data/cs');
            const messages = require('../translations/locales/cs.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/cs.js', 'react-intl/locale-data/cs', '../translations/locales/cs.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/cs.js');
          const localeData = require('react-intl/locale-data/cs');
          const messages = require('../translations/locales/cs.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'da':
        if (hasIntl('da')) {
          require.ensure(['react-intl/locale-data/da', '../translations/locales/da.json'], require => {
            const localeData = require('react-intl/locale-data/da');
            const messages = require('../translations/locales/da.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/da.js', 'react-intl/locale-data/da', '../translations/locales/da.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/da.js');
          const localeData = require('react-intl/locale-data/da');
          const messages = require('../translations/locales/da.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'de':
        if (hasIntl('de')) {
          require.ensure(['react-intl/locale-data/de', '../translations/locales/de.json'], require => {
            const localeData = require('react-intl/locale-data/de');
            const messages = require('../translations/locales/de.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/de.js', 'react-intl/locale-data/de', '../translations/locales/de.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/de.js');
          const localeData = require('react-intl/locale-data/de');
          const messages = require('../translations/locales/de.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'en':
        if (hasIntl('en')) {
          require.ensure(['react-intl/locale-data/en', '../translations/locales/en.json'], require => {
            const localeData = require('react-intl/locale-data/en');
            const messages = require('../translations/locales/en.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/en.js', 'react-intl/locale-data/en', '../translations/locales/en.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/en.js');
          const localeData = require('react-intl/locale-data/en');
          const messages = require('../translations/locales/en.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'es':
        if (hasIntl('es')) {
          require.ensure(['react-intl/locale-data/es', '../translations/locales/es.json'], require => {
            const localeData = require('react-intl/locale-data/es');
            const messages = require('../translations/locales/es.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/es.js', 'react-intl/locale-data/es', '../translations/locales/es.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/es.js');
          const localeData = require('react-intl/locale-data/es');
          const messages = require('../translations/locales/es.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'es-mx':
        if (hasIntl('es-mx')) {
          require.ensure(['react-intl/locale-data/es', '../translations/locales/es-mx.json'], require => {
            const localeData = require('react-intl/locale-data/es');
            const messages = require('../translations/locales/es.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/es-MX.js', 'react-intl/locale-data/es', '../translations/locales/es-mx.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/es-MX.js');
          const localeData = require('react-intl/locale-data/es');
          const messages = require('../translations/locales/es-mx.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'fi':
        if (hasIntl('fi')) {
          require.ensure(['react-intl/locale-data/fi', '../translations/locales/fi.json'], require => {
            const localeData = require('react-intl/locale-data/fi');
            const messages = require('../translations/locales/fi.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/fi.js', 'react-intl/locale-data/fi', '../translations/locales/fi.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/fi.js');
          const localeData = require('react-intl/locale-data/fi');
          const messages = require('../translations/locales/fi.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'fr':
        if (hasIntl('fr')) {
          require.ensure(['react-intl/locale-data/fr', '../translations/locales/fr.json'], require => {
            const localeData = require('react-intl/locale-data/fr');
            const messages = require('../translations/locales/fr.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/fr.js', 'react-intl/locale-data/fr', '../translations/locales/fr.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/fr.js');
          const localeData = require('react-intl/locale-data/fr');
          const messages = require('../translations/locales/fr.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'nl':
        if (hasIntl('nl')) {
          require.ensure(['react-intl/locale-data/nl', '../translations/locales/nl.json'], require => {
            const localeData = require('react-intl/locale-data/nl');
            const messages = require('../translations/locales/nl.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/nl-NL.js', 'react-intl/locale-data/nl', '../translations/locales/nl.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/nl-NL.js');
          const localeData = require('react-intl/locale-data/nl');
          const messages = require('../translations/locales/nl.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'nl-be':
        if (hasIntl('nl-be')) {
          require.ensure(['react-intl/locale-data/nl', '../translations/locales/nl-be.json'], require => {
            const localeData = require('react-intl/locale-data/nl');
            const messages = require('../translations/locales/nl-be.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/nl-BE.js', 'react-intl/locale-data/nl', '../translations/locales/nl-be.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/nl-BE.js');
          const localeData = require('react-intl/locale-data/nl');
          const messages = require('../translations/locales/nl-be.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'nb':
        if (hasIntl('nb')) {
          require.ensure(['react-intl/locale-data/nb', '../translations/locales/nb.json'], require => {
            const localeData = require('react-intl/locale-data/nb');
            const messages = require('../translations/locales/nb.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/nb.js', 'react-intl/locale-data/nb', '../translations/locales/nb.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/nb.js');
          const localeData = require('react-intl/locale-data/nb');
          const messages = require('../translations/locales/nb.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'pl':
        if (hasIntl('pl')) {
          require.ensure(['react-intl/locale-data/pl', '../translations/locales/pl.json'], require => {
            const localeData = require('react-intl/locale-data/pl');
            const messages = require('../translations/locales/pl.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/pl.js', 'react-intl/locale-data/pl', '../translations/locales/pl.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/pl.js');
          const localeData = require('react-intl/locale-data/pl');
          const messages = require('../translations/locales/pl.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'sv':
        if (hasIntl('sv')) {
          require.ensure(['react-intl/locale-data/sv', '../translations/locales/sv.json'], require => {
            const localeData = require('react-intl/locale-data/sv');
            const messages = require('../translations/locales/sv.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/sv.js', 'react-intl/locale-data/sv', '../translations/locales/sv.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/sv.js');
          const localeData = require('react-intl/locale-data/sv');
          const messages = require('../translations/locales/sv.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      default:
        return reject('Unsupported locale');
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/locale-loader.js